export * from './receipt-details.styled.default';
